import { j as r } from "./atoms-v218.js";
import { forwardRef as wt, useRef as st, useState as $, useContext as Rt, useMemo as P, useEffect as ot, useCallback as Pt } from "react";
import at from "./atoms-v2723.js";
import Lt from "./atoms-v2724.js";
import { Icon as O } from "./atoms-v217.js";
import { InputContainer as Ot } from "./atoms-v2114.js";
import { InputHelper as A } from "./atoms-v220.js";
import { InputOutline as At } from "./atoms-v223.js";
import { PhoneInputSkeleton as Ft } from "./atoms-v2725.js";
import { FormGroupContext as zt } from "./atoms-v2130.js";
import { useMergedRefs as Bt } from "./atoms-v2712.js";
import { PhoneInputInterior as Nt, Country as Kt, PhoneInputContainer as Tt, PhoneInputLabel as Wt, Input as Gt, Icons as rt } from "./atoms-v2726.js";
import qt from "./atoms-v2127.js";
import { Menu as Ut, MenuList as _t, OptionComponent as Ht, customStyles as Yt } from "./atoms-v213.js";
import { getDigitsFromString as F, computeMaskState as g, matchCountryFromE164 as Jt, deleteCharRange as X, replaceCharAt as Qt, insertCharAt as it, removeCharAt as Xt } from "./atoms-v2727.js";
import { getCountries as Zt } from "./atoms-v269.js";
import { isPossiblePhoneNumber as vt } from "./atoms-v267.js";
import { parsePhoneNumberWithError as Vt } from "./atoms-v263.js";
import { getCountryCallingCode as C } from "./atoms-v271.js";
import { c as te } from "./atoms-v2134.js";
at.registerLocale(Lt);
const ct = "US", ee = wt(
  ({
    className: lt = "",
    colorTheme: y = "light",
    defaultCountryCode: z = ct,
    defaultValue: D = "",
    disabled: E = !1,
    error: M,
    helperText: B,
    icon: N,
    id: K,
    isSkeleton: ut = !1,
    label: dt,
    name: b,
    onBlur: T,
    onChange: m,
    onFocus: W,
    readOnly: G = !1,
    returnFormattedValue: S = !0,
    selectConfig: mt = {},
    ...pt
  }, ft) => {
    const L = st(null), gt = Bt([ft, L]), q = st(null), [j, yt] = $(null), { isGroupedInput: U } = Rt(zt), _ = Zt(), [Z, ht] = $(""), [v, V] = $(!1), [s, w] = $(z), [p, k] = $(""), [tt, et] = $(!1), x = (t, n, e) => {
      const o = g(t, n), c = Math.min(Math.max(0, e), n.length);
      ht(o.masked), requestAnimationFrame(() => {
        if (L.current) {
          const a = o.localIndexToCaret(c);
          L.current.setSelectionRange(a, a);
        }
      });
    }, xt = (t) => {
      const n = t.currentTarget;
      requestAnimationFrame(() => {
        const e = n.selectionStart ?? 0;
        if ((n.selectionEnd ?? e) > e)
          return;
        const c = g(s, p), a = e, u = c.firstEditableCaret;
        if (a < u) {
          n.setSelectionRange(u, u);
          return;
        }
        const I = c.caretToLocalIndex(a), f = Math.min(p.length, c.maxDigits);
        if (I > f) {
          const l = c.localIndexToCaret(f);
          n.setSelectionRange(l, l);
        }
      });
    }, nt = P(() => {
      const t = at.getNames("en");
      return Object.entries(t).sort((o, c) => {
        const a = o[1].replace(/^the(\s)/i, ""), u = c[1].replace(/^the(\s)/i, "");
        return a.localeCompare(u);
      }).reduce((o, [c, a]) => _.includes(c) ? [...o, { label: a, value: c }] : o, []);
    }, [_]), H = P(
      () => nt.map((t) => ({ mainLabel: t.label, value: t.value })),
      [nt]
    ), St = ({
      children: t,
      innerProps: n,
      ...e
    }) => /* @__PURE__ */ r.jsx(te.ValueContainer, { ...e, ...n, children: Array.isArray(t) ? t[t.length - 1] : null }), kt = P(
      () => ({
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
        Menu: (t) => Ut(t, y),
        MenuList: (t) => _t(t),
        Option: (t) => Ht(t, y, !1),
        Placeholder: () => null,
        ValueContainer: St
      }),
      [y]
    ), Ct = P(
      () => ({
        ...Yt,
        menu: (t) => ({
          ...t,
          boxShadow: "none",
          marginTop: "2px",
          width: j ? `${j}px` : t.width
        }),
        menuPortal: (t) => ({
          ...t,
          zIndex: 1e3
        })
      }),
      [j]
    ), Dt = (t) => {
      var o;
      const n = (t == null ? void 0 : t.value) || s;
      w(n);
      const e = p.length;
      if ((o = L.current) == null || o.focus(), x(n, p, e), m) {
        const c = C(n).toString();
        m(
          S ? g(n, p).masked : `+${c}${p}`
        );
      }
    }, It = (t) => {
      const n = F(t.target.value);
      if (k(n), x(s, n, n.length), m) {
        const e = C(s).toString();
        m(
          S ? g(s, n).masked : `+${e}${n}`
        );
      }
    }, $t = (t) => {
      const n = t.currentTarget, e = n.selectionStart ?? 0, o = n.selectionEnd ?? e, c = g(s, p), { caretToLocalIndex: a, firstEditableCaret: u, localIndexToCaret: I, maxDigits: f } = c;
      if ((t.key === "ArrowLeft" || t.key === "ArrowRight") && !t.shiftKey && e === o) {
        if (t.key === "ArrowLeft") {
          if (e <= u) {
            t.preventDefault(), n.setSelectionRange(u, u);
            return;
          }
          t.preventDefault();
          const l = a(e), d = Math.max(0, l - 1), i = I(d);
          n.setSelectionRange(i, i);
          return;
        }
        if (t.key === "ArrowRight") {
          t.preventDefault();
          const l = a(e), d = Math.min(l + 1, Math.min(p.length, f)), i = I(d);
          n.setSelectionRange(i, i);
          return;
        }
      }
      if ((t.key === "Backspace" || t.key === "Delete") && o > e) {
        t.preventDefault();
        const l = a(e), d = a(o), i = X(p, l, d, f);
        if (k(i), x(s, i, l), m) {
          const h = C(s).toString();
          m(
            S ? g(s, i).masked : `+${h}${i}`
          );
        }
        return;
      }
      if (t.key === "Backspace" && e <= u || t.key === "Delete" && e < u) {
        t.preventDefault(), n.setSelectionRange(u, u);
        return;
      }
      if (/^\d$/.test(t.key)) {
        t.preventDefault();
        const l = a(e), d = a(o);
        let i = p;
        d > l && (i = X(i, l, d, f));
        const h = i.length >= f ? Qt(i, l, t.key, f) : it(i, l, t.key, f);
        if (k(h), x(s, h, Math.min(l + 1, f)), m) {
          const Q = C(s).toString();
          m(
            S ? g(s, h).masked : `+${Q}${h}`
          );
        }
        return;
      }
      if (t.key.length === 1 && /\D/.test(t.key) && !(t.ctrlKey || t.metaKey)) {
        t.preventDefault();
        return;
      }
      if (t.key === "Backspace" || t.key === "Delete") {
        t.preventDefault();
        const l = a(e);
        let d = p, i = l;
        const h = t.key === "Backspace" ? Math.max(0, l - 1) : l;
        if (h < d.length && (d = Xt(d, h), i = h), k(d), x(s, d, i), m) {
          const Q = C(s).toString();
          m(
            S ? g(s, d).masked : `+${Q}${d}`
          );
        }
      }
    }, Et = (t) => {
      t.preventDefault();
      const n = F(t.clipboardData.getData("text"));
      if (!n)
        return;
      const e = t.currentTarget, o = g(s, p), { caretToLocalIndex: c, maxDigits: a } = o, u = c(e.selectionStart ?? 0), I = c(e.selectionEnd ?? u);
      let f = p;
      I > u && (f = X(f, u, I, a));
      const l = Math.max(0, a - f.length), d = n.slice(0, l), i = it(f, u, d, a);
      if (k(i), x(s, i, Math.min(u + d.length, a)), m) {
        const h = C(s).toString();
        m(
          S ? g(s, i).masked : `+${h}${i}`
        );
      }
    }, Mt = (t) => {
      V(!1), T && typeof T == "function" && T(t);
    }, bt = (t) => {
      V(!0);
      const n = t.currentTarget, e = g(s, p), o = Math.min(p.length, e.maxDigits), c = e.localIndexToCaret(o);
      requestAnimationFrame(() => {
        try {
          n.setSelectionRange(c, c);
        } catch {
        }
      }), W && typeof W == "function" && W(t);
    };
    ot(() => {
      const t = z || ct;
      if (D !== "") {
        if (vt(D)) {
          const e = Vt(D);
          e.country && w(e.country);
          const o = F(e.nationalNumber || "");
          if (k(o), x(e.country || s, o, o.length), m) {
            const c = C(e.country || s).toString();
            m(
              S ? g(e.country || s, o).masked : `+${c}${o}`
            );
          }
          return;
        }
        if (D.trim().startsWith("+")) {
          const e = Jt(D, _);
          if (e) {
            if (w(e.country), k(e.localDigits), x(e.country, e.localDigits, e.localDigits.length), m) {
              const o = C(e.country).toString();
              m(
                S ? g(e.country, e.localDigits).masked : `+${o}${e.localDigits}`
              );
            }
            return;
          }
        }
        const n = F(D);
        if (w(t), k(n), x(t, n, n.length), m) {
          const e = C(t).toString();
          m(
            S ? g(t, n).masked : `+${e}${n}`
          );
        }
        return;
      }
      w(t), k(""), x(t, "", 0);
    }, [z, D]);
    const Y = Pt(() => {
      const t = q.current;
      if (!t)
        return;
      const n = t.getBoundingClientRect().width;
      n > 0 && n !== j && yt(n);
    }, [j]);
    ot(() => {
      const t = q.current;
      if (!t)
        return;
      const n = () => Y();
      n();
      const e = new ResizeObserver(n);
      return e.observe(t), window.addEventListener("resize", n), () => {
        e.disconnect(), window.removeEventListener("resize", n);
      };
    }, [Y]);
    const jt = P(
      () => H.find((t) => t.value === s) || null,
      [H, s]
    );
    if (ut)
      return /* @__PURE__ */ r.jsx(Ft, { helperText: B });
    const R = !!M, J = `${b}_errormessage`;
    return /* @__PURE__ */ r.jsxs(Ot, { className: lt, children: [
      /* @__PURE__ */ r.jsxs(
        At,
        {
          colorTheme: y,
          isDisabled: E || G,
          isErrored: R,
          isFocused: !1,
          isGroupedInput: U,
          children: [
            /* @__PURE__ */ r.jsxs(Nt, { ref: q, children: [
              /* @__PURE__ */ r.jsx("div", { style: { gridArea: "1 / 1 / 2 / 2", width: "100%" }, children: /* @__PURE__ */ r.jsx(
                qt,
                {
                  closeMenuOnSelect: !0,
                  components: kt,
                  hideSelectedOptions: !1,
                  inputId: K || b,
                  isDisabled: E,
                  isSearchable: !1,
                  menuPlacement: "auto",
                  menuPortalTarget: document.body,
                  onBlur: () => {
                    et(!1);
                  },
                  onChange: (t) => Dt(t),
                  onFocus: () => {
                    et(!0);
                  },
                  onMenuOpen: () => {
                    Y();
                  },
                  options: H,
                  styles: Ct,
                  value: jt,
                  ...mt
                }
              ) }),
              /* @__PURE__ */ r.jsxs(
                Kt,
                {
                  "aria-hidden": !0,
                  $colorTheme: y,
                  $isDisabled: E || G,
                  $isFocused: tt,
                  children: [
                    /* @__PURE__ */ r.jsx(O, { name: `country-${s == null ? void 0 : s.toLowerCase()}`, size: "large" }),
                    /* @__PURE__ */ r.jsx(O, { name: "chevron-down", size: "medium" })
                  ]
                }
              ),
              /* @__PURE__ */ r.jsxs(Tt, { $isFocused: v && !tt, children: [
                /* @__PURE__ */ r.jsx(
                  Wt,
                  {
                    colorTheme: y,
                    hasValue: Z !== "",
                    htmlFor: K || b,
                    isDisabled: E,
                    isFocused: v,
                    children: dt
                  }
                ),
                /* @__PURE__ */ r.jsx(
                  Gt,
                  {
                    $colorTheme: y,
                    "aria-invalid": R,
                    disabled: E,
                    id: K || b,
                    name: b,
                    onBlur: Mt,
                    onChange: It,
                    onClick: xt,
                    onFocus: bt,
                    onKeyDown: $t,
                    onPaste: Et,
                    readOnly: G,
                    ref: gt,
                    type: "tel",
                    value: Z,
                    ...R && { "aria-describedby": J },
                    ...pt
                  }
                ),
                N ? /* @__PURE__ */ r.jsx(rt, { $colorTheme: y, children: N && /* @__PURE__ */ r.jsx(O, { name: N, size: "medium" }) }) : null,
                R ? /* @__PURE__ */ r.jsx(rt, { $isErrored: !0, $colorTheme: y, children: R && /* @__PURE__ */ r.jsx(O, { name: "warning-filled", size: "medium" }) }) : null
              ] })
            ] }),
            U ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
              /* @__PURE__ */ r.jsx(A, { isGroupedInput: !0, colorTheme: y, children: !M && B }),
              /* @__PURE__ */ r.jsx(A, { isError: !0, isGroupedInput: !0, colorTheme: y, id: J, children: M })
            ] }) : null
          ]
        }
      ),
      U ? null : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        /* @__PURE__ */ r.jsx(A, { colorTheme: y, children: !M && B }),
        /* @__PURE__ */ r.jsx(A, { isError: !0, colorTheme: y, id: J, children: M })
      ] })
    ] });
  }
);
ee.displayName = "PhoneInput";
export {
  ee as PhoneInput
};
